<template>
  <v-app>
    <v-main class="login-background">
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Đăng nhập</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-alert
                  v-if="loginError"
                  type="error"
                  dismissible
                  class="mb-4"
                  @input="loginError = ''"
                >
                  {{ loginError }}
                </v-alert>
                <v-form @submit.prevent="handleLogin" ref="form" v-model="valid">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    name="email"
                    prepend-icon="mdi-email"
                    type="email"
                    required
                    @input="loginError = ''"
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    :rules="passwordRules"
                    label="Mật khẩu"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    required
                    @input="loginError = ''"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  variant="elevated"
                  size="large"
                  @click="handleLogin"
                  :loading="loading"
                  :disabled="!valid"
                >
                  Đăng nhập
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from '@/http';
export default {
  name: 'Login',
  data() {
    return {
      valid: false,
      loading: false,
      email: '',
      password: '',
      loginError: '',
      emailRules: [
        v => !!v || 'Email là bắt buộc',
        v => /.+@.+\..+/.test(v) || 'Email phải hợp lệ',
      ],
      passwordRules: [
        v => !!v || 'Mật khẩu là bắt buộc',
        v => v.length >= 6 || 'Mật khẩu phải có ít nhất 6 ký tự',
      ],
    }
  },
  methods: {
    async handleLogin() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.loading = true
      this.loginError = ''
      try {
        // Gọi API đăng nhập
        const response = await axios.post('/users/login', {
          email: this.email,
          password: this.password
        });
        const { token, user } = response.data;
        // Lưu token và user vào localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        // Chuyển hướng về trang chủ
        this.$router.push('/admin/dashboard');
      } catch (error) {
        console.error('Login error:', error);
        this.loginError = error.response?.data?.message || 'Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin.';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.login-background {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
</style> 